import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M14 8V2H6.29C5.02 2 4 2.9 4 4V20C4 21.1 5.02 22 6.29 22H17.71C18.98 22 20 21.1 20 20V8H14ZM17 18H7V11H17V18Z"
      fill="currentColor"
    />
    <path d="M20 7H15V2L20 7Z" fill="currentColor" />
    <path d="M8 12H9V13H8V12Z" fill="currentColor" />
    <path d="M15 12H16V13H15V12Z" fill="currentColor" />
    <path d="M10 12H14V13H10V12Z" fill="currentColor" />
    <path d="M8 14H9V15H8V14Z" fill="currentColor" />
    <path d="M15 14H16V15H15V14Z" fill="currentColor" />
    <path d="M10 14H14V15H10V14Z" fill="currentColor" />
    <path d="M8 16H9V17H8V16Z" fill="currentColor" />
    <path d="M15 16H16V17H15V16Z" fill="currentColor" />
    <path d="M10 16H14V17H10V16Z" fill="currentColor" />
  </>
);

const Icon = createSvgIcon(svg, 'FileTable');

export default Icon;
